import { createAction } from "@reduxjs/toolkit";

const filter = createAction("events/filter");

export default { filter };
